module.exports = __webpack_public_path__ + "static/img/fpi-300x300.bd8ef91e.jpg";